import { validateURL } from "./email-validator";
import vv_c from "./vv_c";
import { getCookie, getData } from './utils';

///////////Polyfill for event submitter
//https://stackoverflow.com/questions/2066162/how-can-i-get-the-button-that-caused-the-submit-from-the-form-submit-event
/* eslint-disable */
!function () {
  var lastBtn = null
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    lastBtn = e.target.closest('button, input[type=submit]');
  }, true);
  document.addEventListener('submit', function (e) {
    if ('submitter' in e) return;
    var canditates = [document.activeElement, lastBtn];
    lastBtn = null;
    for (var i = 0; i < canditates.length; i=i+1) {
      var candidate = canditates[i];
      if (!candidate) continue;
      if (!candidate.form) continue;
      if (!candidate.matches('button, input[type=button], input[type=image]')) continue;
      e.submitter = candidate;
      return;
    }
    e.submitter = e.target.querySelector('button, input[type=button], input[type=image]')
  }, true);
}();
/* eslint-enable */

function fixedEncodeURIComponent(str) {
  return encodeURIComponent(str).replace(/[!'()]/g, escape).replace(/\*/g, "%2A");
}

const vvenc = (strings, ...values) => {
  let result = strings.map((str, i) => str + (fixedEncodeURIComponent(values[i] ?? "")));
  return result.join("");
}

function sleep(milliseconds) {
  const date = Date.now();
  let currentDate = null;
  do {
    currentDate = Date.now();
  } while (currentDate - date < milliseconds);
}
//This adds the right event handlers for a normal input form for change and input
function addFormAndMachineServiceChangeAndInputHandlers(form, service, submitEventHandler) {
  form.addEventListener('change', (event) => {
    service.send("CHANGE");
  })
  form.addEventListener('submit', (event) => {
    let submitResult = submitEventHandler(event, service);
    event.preventDefault();
    event.stopPropagation();
    if (form.classList.contains("needs-validation")) {
      form.classList.add("was-validated");
    }
    if (submitResult && typeof submitResult === 'string' && submitResult.toLowerCase() === 'input') {
      service.send("INPUT");
    } else {
      service.send("SUBMIT");
    }
  })
}


//For large forms this makes it easy to bind a bunch of fields to events using selectors
function AttachAndSendFormEventsToMachineService(form, service, selector, eventname) {
  let nodeListToAddEvents = form.querySelectorAll(selector);
  if (nodeListToAddEvents && nodeListToAddEvents.length > 0) {
    Object.values(nodeListToAddEvents).forEach(function (node) {
      node.addEventListener(eventname, (event) => {
        service.send(event.type.toUpperCase());
      })
    })
  }
}

/* eslint-disable no-param-reassign */
const clearalert = (alertbox) => {
  alertbox.innerText = "";
  alertbox.classList.remove('show');
  alertbox.classList.add('hide');
}
/* eslint-enable no-param-reassign */

/* eslint-disable no-param-reassign */
//TODO figure out how to make this more dynamic (to support more style classes)
const showalert = (message, type, alertbox) => {
  alertbox.innerHTML = message;

  if (type === 'primary') {
    alertbox.classList.remove('alert-warning');
    alertbox.classList.remove('alert-danger');
    alertbox.classList.add('alert-primary');
  }
  else if (type === 'warning') {
    alertbox.classList.remove('alert-primary');
    alertbox.classList.remove('alert-danger');
    alertbox.classList.add('alert-warning');
  }
  else if (type === 'danger') {
    alertbox.classList.remove('alert-primary');
    alertbox.classList.remove('alert-warning');
    alertbox.classList.add('alert-danger');
  }
  alertbox.classList.remove('hide');
  alertbox.classList.add('show');
  alertbox.scrollIntoView({ behavior: 'smooth' });
}
/* eslint-enable no-param-reassign */

/* eslint-enable no-param-reassign */
function showInnerErrors(defaultmessage, error, alertbox) {
  //eslint-disable-next-line
  if (error && (error instanceof ShowableException || error instanceof TimeoutException)) {
    //eslint-disable-next-line
    const template = document.getElementById('spanLinkLookup');
    const alertHTML = template ? template.content.getElementById(error.code) : null;
    if (error.code && alertHTML) {
      showalert(alertHTML.innerHTML, 'danger', alertbox);
    } else {
      showalert(error.message, 'danger', alertbox);
    }
  } else {
    showalert(defaultmessage, "danger", alertbox);
  }
}


/* eslint-disable no-param-reassign */
function showErrors(defaultmessage, errorCB, alertbox) {
  let error = errorCB.errorBuffer;
  showInnerErrors(defaultmessage, error, alertbox);
}
/* eslint-enable no-param-reassign */

/* eslint-enable no-param-reassign */
function showStateErrors(defaultmessage, error, alertbox) {
  showInnerErrors(defaultmessage, error, alertbox);
}

//Used to get a client side time in a fetch call
const Timeout = (time) => {
  let controller = new AbortController();
  setTimeout(() => controller.abort(), time * 1000);
  return controller;
}

const defaultTimeout = 5;

const timeoutMessage = "The request timed out, please check your network connection.";

//also add to variables.pug
const messageMap = {
  "101": timeoutMessage,

  "login_creds_invalid": "Wrong email or password.",
  "login_email_unverified": ["The email address for this account is still unverified, ", "verify now."],
  "signup_username_taken": "That username is taken, please use another unique name.",
  "signup_field_invalid": "The {{field}} is invalid.",
  "signup_agreement_missing" : "The terms of service and privacy policy must be agreed to.",
  "reset_field_invalid" : "The {{field}} is invalid.",
  "domain_name_taken" : "That name is taken, please choose another.",
  "unavailable": "Our services are unavailable, check our twitter feed for udpates.",
  "password_invalid": "Wrong email or password.",
  "email_unknown": "Wrong email or password.",
  "email_unverified": ["The email address for this account is still unverified, ", "verify now."],
  "email_unavailable": "That email or account is taken, please use a different email or social account.",
  "social_unavailable": "That account is taken, please use a different social account.",
  "resource_conflict": "That account is taken, please use a different email or social account.",
  "field_invalid": "The {{field}} is invalid.",
  "agreement_missing": "The terms of service and/or privacy policy must be agreed to.",
  "email_credential_is_social": "That email address was already used by a social login (Google, Facebook, etc.), use the social login buttons below.",
  "email_credential_is_password": "That email address was already used with a password login.",
  "email_credential_is_webauthn": "That email address was already used by a Passkey login (hardware FIDO token, etc.), use the Passkey button below.",
  "webauthn_failure": "That security key is invalid for that account.",
  "email_code_invalid": "That code is invalid.",
  "token_invalid": "That token is invalid and could not be verified.",
  "service_unavailable": "Our services are currently unavailable.",
  "service_failure": "Our services are currently unavailable.",
  "system_failure": "Our services are currently unavailable.",
  "request_invalid": "That request was invalid and could not be processed.",

  "oidc_failure": "Our services are currently unavailable.",
  "oidc_client_invalid": "Client ID is invalid.",
  "oidc_redirect_invalid": "Client redirect URL is invalid.",
  "requires_approval": "Registration is submitted, and is now pending approval.",
  "user_disabled": "Account is not approved for access yet.",
  "signups_disabled": "That account does not exist, and new accounts can not be added this way, please use a different account that is already registered.",
  "invalid_tenant" : "That tenant id is invalid.",
  "resource_unknown" : "The requested resource was not found.",
  "resource_quota": "Unable to create, your quota for this plan is full",
}

function SessionExpirationException(message) {
  this.message = message;
}
SessionExpirationException.prototype = new Error();

function ShowableException(message) {
  this.message = message;
}
ShowableException.prototype = new Error();

function TimeoutException(message) {
  this.message = message;
}
TimeoutException.prototype = Object.create(Error.prototype);

function NotFoundException(message) {
  this.message = message;
}
NotFoundException.prototype = new Error();

function GenericException(message) {
  this.message = message;
}
GenericException.prototype = new Error();

function MetaException(code, message, fields, response) {
  let error;
  switch (code) {

    case '101':
      error = new TimeoutException(timeoutMessage);
      this.prototype = Object.create(TimeoutException.prototype);
      break;
    //break - uncommet if return removed;
    case 'field_invalid':
      error = new ShowableException(message);
      if (fields.length > 0) {
        error.fields = fields;
      }
      this.prototype = Object.create(ShowableException.prototype);
      break;
    //break - uncomment if return removed;
    case 'password_invalid':
    case 'email_unknown':
    case 'email_unverified':
    case 'email_unavailable':
    case 'social_unavailable':
    case 'resource_conflict':
    case 'agreement_missing':
    case 'email_credential_is_social':
    case 'email_credential_is_password':
    case 'email_credential_is_webauthn':
    case 'webauthn_failure':
    case 'token_invalid':
    case 'service_unavailable':
    case 'service_failure':
    case 'system_failure':
    case 'request_invalid':
    case 'email_code_invalid':
    case 'requires_approval':
    case 'user_disabled':
    case 'signups_disabled':
    case 'login_creds_invalid':
    case 'login_email_unverified':
    case 'signup_username_taken':
    case 'signup_field_invalid':
    case 'signup_agreement_missing':
    case 'domain_name_taken':
    case 'resource_quota':
      error = new ShowableException(message);
      this.prototype = Object.create(ShowableException.prototype);
      break;
    //break - uncommet if return removed;
    case 'resource_unknown':
      error = new NotFoundException(message);
      this.prototype = Object.create(NotFoundException.prototype);
      break;
    //break - uncommet if return removed;
    default:
      error = new GenericException(message);
      this.prototype = Object.create(GenericException.prototype);
      break;
    }

  error.response=response;
  error.code = code;
  return error;
}
/*
Used as the first .then for fetch calls to parse out HTTP errors
and to get them to our global JS error tracker
Basic tiering of error parsing goes like:
- Is the response even JSON, if yes than try to get info about it
-   For JSON, see if it is our 'Kind-Error' of JSON with a top level Kind element
-     If it is not Kind JSON then try to get info from HTTP Codes and Body elements

-For all NON JSON, Skip the 'Kind-Error' and go straight to HTTP Code and Body elements
*/
const handleJSONRequestErrors = (response) => {
  const emptyJSON = {}; emptyJSON.json = ()=>{return {}};
  
  
  //check for a non JSON Content-Type

  let contentType = response.headers.get('Content-Type');
  //just return if the contentType is what we expect,
  //the rest of the fetch then post json can now parse
  if (contentType && contentType.startsWith('application/json')) {
    //now check the 404 and 401 types
    if (response.status === 401) {
      //check if it is relative or going back to the same domain as the window
      if (response.url.startsWith("/") || response.url.includes(window.location.hostname)) {
        throw new SessionExpirationException('Session Expired');
      } else {
        throw new Error('Access Unauthorized - 401');
      }
    } else if (response.status === 404) {
      //check if it is relative or going back to the same domain as the window
      if (response.url.startsWith("/") || response.url.includes(window.location.hostname)) {
        //do nothing, this will be handled as part of the handleCustomExceptions
      } else {
        throw new Error('Access Unauthorized - 404');
      }
    }
    return response;
  } else {
    //now we know it was not json let's check HTTP codes
    //first check if it is a known no content and retun an empty JSON object
    if (response.status==="204" || response.status===204) {
      return emptyJSON;
    }
    else if (!response.ok) {
      throw new Error("Unusable response data from: " + response.url + " status code: " + response.status + " statusText: " + response.statusText);
    } else {
      //the request is okay, maybe it is a suitable content type that can still be parsed
      // eslint-disable-next-line
      if ((contentType.slice(0, 5) === 'text/') || (contentType.slice === 'application/javascript') || (contentType.slice === 'application/ld+json')) {
        if (JSON.parse(response.text())) {
          return response;
        }
        else {
          // eslint-disable-next-line
          throw new Error("JSON response data from: " + response.url + " was unparseable, contentType: " + contentType + " status code: " + response.status);
        }
      } else {
        // eslint-disable-next-line
        throw new Error("Response data from: " + response.url + " was wrong contentType, expected application/json, got contentType: " + contentType + " status code: " + response.status);
      }
    }
  }

}


const buildSpanLinkLookup = () => {
  //now append that authstate to any links that have the appendAuthState class assigned
  let template = document.getElementById('spanLinkLookup');
  let nodeList = template ? template.content.querySelectorAll('span.spanLinkLookup') : null;
  if (nodeList && nodeList.length > 0) {
    Object.values(nodeList).forEach(function (node) {
      //now insert the looks based on position of template placeholders
      let spantext = node.innerHTML;
      let segments = spantext.split('{{$s}}');
      let message = messageMap[node.getAttribute('id')]
      //makes sure any strings are turned in Arrays because we are going to match their length
      if (!Array.isArray(message)) {
        message = [message];
      }
      //match the sizes of the arrays, message needs to be one less to fill in
      // all the elements in segements
      while ((message.length) < segments.length - 1) {
        message.push("");
      }
      //now make sure segments wasn't short
      while ((segments.length - 1) < message.length) {
        segments.push("");
      }
      //now finger weave the 2 arrays together with message going inside the segments,
      //the last element has nothing added because we are finger weaving a small into larger
      let output = segments.map((element, index) => {
        if (index + 1 === segments.length) {
          return element;
        } else {
          return element + message[index];
        }
      })
      //eslint-disable-next-line no-param-reassign
      node.innerHTML = output.join('');

    })
  }

}

const ensureAuthState = () => {
  const urlparams = new URLSearchParams(window.location.search);
  const authstate = urlparams.get('authstate');
  const beenhere = urlparams.get('beenhere');
  const host = window.location.hostname;
  const localhost = host.indexOf('localhost') || host.indexOf('127.0.0.1') || host.indexOf('::1');
  //try a quick redirect if we got here somehow without authstate, but only do it once
  if ((!authstate && !beenhere && !localhost)) {
    window.location.replace("/?beenhere=1");
  }

  if (authstate) {
    //now append that authstate to any links that have the appendAuthState class assigned
    let normalLinks = document.querySelectorAll('a.appendAuthState');
    let template = document.getElementById('spanLinkLookup');
    let templateLinks = template ? template.content.querySelectorAll('a.appendAuthState') : null;

    let nodeList = [];
    //eslint-disable-next-line prefer-spread
    nodeList.push.apply(nodeList, normalLinks);
    //eslint-disable-next-line prefer-spread
    nodeList.push.apply(nodeList, templateLinks);
    
    if (nodeList && nodeList.length > 0) {
      Object.values(nodeList).forEach(function (node) {
        
        let href = node.getAttribute('href');
        if (!href.includes('authstate=')) {
          if (href.includes('?')) {
            href = href + "&authstate=" + authstate;
          } else {
            href = href + "?authstate=" + authstate;
          }
          node.setAttribute('href', href);
        }
      })
    }
  }

  return authstate;
}

const pageManager = {
  'authstate': null
}

function showSessionModal() {
  var sessionExpiredModal = new window.bootstrap.Modal(document.getElementById('staticBackdrop'));
  sessionExpiredModal.toggle();
}

document.addEventListener("DOMContentLoaded", function () {
  buildSpanLinkLookup();
  pageManager.authstate = ensureAuthState();
});

function handleCustomExceptions(response) {
  // check if this is a custom Error, order matters because customs ARE Errors as well
  // and need to be checked first
  // inputs could be either existing errors or reponse calls with error kind.
  //Do the best to translate

  
  
  if ((response instanceof TimeoutException) ||
    (response instanceof NotFoundException) ||
    (response instanceof ShowableException) ||
    (response instanceof GenericException)) {
    //don't do anything, the expection is already good re-throw
    throw response
  }

  if (response instanceof SessionExpirationException) {
    //show the session timeout modal
    showSessionModal();
    throw response
  }

  // check if this is a basic Error that we know is safe to show the user based on it's message
  if (response instanceof Error) {
    switch (response.message) {
      //this is a known timeout
      case 'DOMException: Aborted':
        throw new TimeoutException(timeoutMessage);
      case 'AbortError: Aborted':
        throw new TimeoutException(timeoutMessage);
      case 'Aborted':
        throw new TimeoutException(timeoutMessage);
      default:
        throw response;
    }
  }

  //check for a 204 - no content but no error
  if (response.status === 204) {
    return;
  }

  // now try to figure out custom Error kinds and map to the right exception
  const responseAsString = JSON.stringify(response);
  if (!responseAsString) {
    throw new GenericException("Did not get a Kind-Response-Error, got response as undefined on stringify");
  }

  if ((response.kind && (response.kind.toLowerCase() === 'error' || response.kind.toLowerCase().endsWith('error'))) ||
    (response.type && (response.type.toLowerCase() === 'error' || response.type.toLowerCase().endsWith('error')))
  ) {
    //check if there is a redirect before assigning a code
    if (response.redirect) {
      window.location.assign(response.redirect);
      return;
    }
    let code = response.code ? String(response.code) : "0";
    let message = '';
    let fields = [];

    if (response.message) {
      message = messageMap[code] ? messageMap[code] : response.message;
    } else {
      message = messageMap[code] ? messageMap[code] : code;
    }

    //replace field names if needed
    if (message.includes("{{field}}") && response.fields) {
      let arrNames = [];
      response.fields.forEach((field) => {
        arrNames.push(field.name);
        fields.push(field.name);
      })
      message = message.replace("{{field}}", arrNames.join(", "));
    }

    throw new MetaException(code, message, fields, response);
  }
  else {
    // eslint-disable-next-line
    const snippet = responseAsString.slice(0, responseAsString.length > 200 ? 200 : responseAsString.length);
    throw new GenericException("Did not get a Kind-Response-Error, got: " + snippet);
  }

}

//timeout is in seconds
// eslint-disable-next-line max-len
const vv_fetch = async (URL, requestBody, responseCB, failCB, responseKind, method = 'POST', timeout = defaultTimeout) => {
  const options = {
    signal: Timeout(timeout).signal,
    method: method,
    headers: {
      'Content-Type': 'application/json',
      'X-VaultVision-CSRF-Nonce': window.vv_csrftoken,
      'Accept': 'application/json',
    },
  }
  if (!method || typeof method !== 'string' || (method.toUpperCase() !== 'GET' && method.toUpperCase() !== 'HEAD')) {
    options['body'] = JSON.stringify(requestBody);
  }

  await fetch(URL, options)
    .then(handleJSONRequestErrors)
    .then(response => {
      return response.json();
    })
    .then((jsonResponse) => {
      
      if ((jsonResponse.kind && (jsonResponse.kind.toLowerCase() === 'error' || jsonResponse.kind.toLowerCase().endsWith('error'))) ||
        (jsonResponse.type && (jsonResponse.type.toLowerCase() === 'error' || jsonResponse.type.toLowerCase().endsWith('error')))
      ) {
        
        handleCustomExceptions(jsonResponse);
      }
      else {
        responseCB(jsonResponse);
        return;
      }
    })
    .catch(error => {
      //on last chance to handle a known custom error
      handleCustomExceptions(error);
      throw error;
    })
    .catch(function (err) {
      failCB(err);
    });
}

const vv_fetch_state = (URL, requestBody, method = "POST", timeout = defaultTimeout) => {
  const options = {
    signal: Timeout(timeout).signal,
    method: method,
    headers: {
      'Content-Type': 'application/json',
      'X-VaultVision-CSRF-Nonce': window.vv_csrftoken,
      'Accept': 'application/json',
    },
  }
  if (!method || typeof method !== 'string' || (method.toUpperCase() !== 'GET' && method.toUpperCase() !== 'HEAD')) {
    options['body'] = JSON.stringify(requestBody);
  }

  return fetch(URL, options)
    .then(handleJSONRequestErrors)
    .then(response => response.json())
    .then((jsonResponse) => {
      if ((jsonResponse.kind && (jsonResponse.kind.toLowerCase() === 'error' || jsonResponse.kind.toLowerCase().endsWith('error'))) ||
        (jsonResponse.type && (jsonResponse.type.toLowerCase() === 'error' || jsonResponse.type.toLowerCase().endsWith('error')))
      ) {
        
        handleCustomExceptions(jsonResponse);
      }
      
      return jsonResponse;
    })
    .catch(error => {
      
      //on last chance to handle a known custom error
      handleCustomExceptions(error);
      throw error;
    });
}


function generateCSV(array) {
  
  var keys = Object.keys(array[0]);
  var csv = keys.join("\,") + "\n";
  array.forEach(function (obj) {
    csv += keys.map(k => {
      if (typeof obj[k] === "object" && obj[k] !== null) {
        let value = `"${Object.values(obj[k]).join(",")}"`;
        return value;
      }
      return obj[k];
    }).join("\,") + "\n";
  });
  return csv;
}

function detectWebAuthnSupport() {
  return new Promise((resolve, reject) => {

    if (window.PublicKeyCredential) {
     window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()
       .then((available) => {
         if (available) {
           resolve("platform supported");
         } else {
           resolve("supported but no platform");
         }
       })
       .catch((err) => reject(new Error('not supported')));
    } else {
      reject(new Error('not supported'));
    }

  })
}


function bufToStr(buf) {
  return String.fromCharCode.apply(null, new Uint8Array(buf));
}

//used for webauthn
function b64Decode(value) {
  const v = value.replace(/-/g, '+').replace(/_/g, '/');
  return Uint8Array.from(atob(v), c => c.charCodeAt(0));
}

function b64Encode(value) {
  return btoa(String.fromCharCode.apply(null, new Uint8Array(value)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");
}

//used for normal UTF-8 strings
function b64_to_utf8(str) {
  return decodeURIComponent(escape(window.atob(str)));
}
function utf8_to_b64(str) {
  return window.btoa(unescape(encodeURIComponent(str)));
}

function splitAndTrim(urls) {
  return urls.split(/[\,\t\n]/).map((url) => url.trim());
}

function validateArrayUrl(urlStrip) {
  //split the array on comma, tab, and newline
  let urls = urlStrip.split(/[\,\t\n]/);
  //map the array through validation to get an array of trues and falses
  let checked = urls.map((url) => validateURL(url.trim()));
  //return false if there is even one false
  return checked.every(Boolean);
}


async function logError(error) {

  let support = await detectWebAuthnSupport();

  let userstate = { 'location': window.location.href, 'message': '', 'data': {} };
  userstate.data.typeof = typeof (error);
  userstate.data.userAgent = window.navigator.userAgent;
  userstate.data.userAgentData = JSON.stringify(window.navigator.userAgentData);
  userstate.data.cookieEnabled = JSON.stringify(window.navigator.cookieEnabled);
  userstate.data.webAuthnSupport = support;
  userstate.data.referrer = document.referrer;

  if (error) {
    if (error.message) {
      userstate.message = String(error.message);
    }
    if (error.stack) {
      userstate.data.stack = String(error.stack);
    }
    if (error.columnNumber) {
      userstate.data.columnNumber = String(error.columnNumber);
    }
    if (error.fileName) {
      userstate.data.fileName = String(error.fileName);
    }
    if (error.lineNumber) {
      userstate.data.lineNumber = String(error.lineNumber);
    }
    if (error.name) {
      userstate.data.name = String(error.name);
    }
    if (error.code) {
      userstate.data.code = String(error.code);
    }
  }

  function successCB(response) {
  }

  function finishCB(finishResponse) {
  }

  vv_fetch(vvenc`/v1/report`, userstate, successCB, finishCB, 'remove', 'POST');
}


function formatTime(UTCString) {
  var d = new Date(UTCString);
  var currentHour = d.getHours();
}

function makeInvalid(name){
  let fields = null;
  if(typeof(name) === "string"){
    fields = document.querySelectorAll(name);
    for (let i=0; i < fields.length; i=i+1) {
      fields[i].classList.remove('is-valid');
      fields[i].classList.add('is-invalid');
      if (fields[i].form) {
        fields[i].form.classList.remove('was-validated');
      }
    }
  } else if (name) {
    fields = name;
    fields.classList.remove("is-valid");
    fields.classList.add("is-invalid");
  
    //fields.form.classList.remove("was-validated");
  }
}

function clearInputValidation(form) {
  form.classList.remove("was-validated");
  let inputEls = form.querySelectorAll(".is-invalid");
  //removes .is-invalid class
  inputEls.forEach(formInput => {
    formInput.classList.remove('is-invalid');
  })
  inputEls = form.querySelectorAll(".is-valid");
  //removes .is-valid class
  inputEls.forEach(formInput => {
    formInput.classList.remove('is-valid');
  })
}

function handleExport (data){
  if(data.length > 0){
    const csv = generateCSV(data);
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    a.setAttribute("download", `vv-${Date.now()}.csv`);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);  
  }
}  
function addTracking(goalId, rev) {
  let mtmimg = document.getElementById('mtmimg');
  if (mtmimg && window.location.host.toLowerCase() === 'auth.vaultvision.com') {
    let vv_pk_id = document.cookie.split('; ').filter(x => x.startsWith("_pk_id"));
    //["_pk_id.1.1fff=518558de9068b852.1659981196."]
    //want "518558de9068b852"
    if (vv_pk_id && vv_pk_id.length > 0 && vv_pk_id[0].includes("=")) {
      vv_pk_id = decodeURIComponent(vv_pk_id[0].split("=")[1]).split(".")[0];
    } //else leave as is and let it log  

    /* eslint-disable no-underscore-dangle */
    let _rcn = "";
    let _rck = "";

    try {
      _rcn = b64_to_utf8(getCookie("_rcn"));
      _rck = b64_to_utf8(getCookie("_rck"));
    } catch {
      //no catch, just means cookie is corrupt
    }

    let imgsrc = vv_c.VV_MATOMO_URL + "&action_name="
      + fixedEncodeURIComponent(window.location.pathname.toLowerCase());
    if (vv_pk_id) {
      imgsrc = imgsrc + "&_id=" + fixedEncodeURIComponent(String(vv_pk_id));
    }
    if (_rcn) {
      imgsrc = imgsrc + "&_rcn=" + fixedEncodeURIComponent(String(_rcn));
    }
    if (_rck) {
      imgsrc = imgsrc + "&_rck=" + fixedEncodeURIComponent(String(_rck));
    }
    if (goalId) {
      imgsrc = imgsrc + "&idgoal=" + fixedEncodeURIComponent(String(goalId));
    }
    //check float
    if (rev && !Number.isNaN(rev) && parseFloat(rev) < 100000) {
      imgsrc = imgsrc + "&revenue=" + fixedEncodeURIComponent(String(rev));
    }
    mtmimg.src = imgsrc;
    /* eslint-enable no-underscore-dangle */
  }


}

function highlightFields(fields, fieldFormMap) {
  //fields is an array
  // ['require_mfa', 'privacy_policy_version', 'handle_if_missing']
  if (fields && fields.length > 0) {
    const invalidIds = fields.map((field) => {
      return fieldFormMap[field];      
    });
    if (invalidIds && invalidIds.length > 0) {
      invalidIds.forEach((id) => {
        makeInvalid(id);
      })
    }
  }
}
const vv_utils = {
  addFormAndMachineServiceChangeAndInputHandlers,
  clearalert,
  showalert,
  showErrors,
  AttachAndSendFormEventsToMachineService,
  handleJSONRequestErrors,
  Timeout,
  defaultTimeout,
  messageMap,
  ShowableException,
  TimeoutException,
  NotFoundException,
  GenericException,
  MetaException,
  buildSpanLinkLookup,
  ensureAuthState,
  pageManager,
  handleCustomExceptions,
  vv_fetch,
  detectWebAuthnSupport,
  bufToStr,
  b64Decode,
  b64Encode,
  b64_to_utf8,
  utf8_to_b64,
  fixedEncodeURIComponent,
  vvenc,
  splitAndTrim,
  validateArrayUrl,
  generateCSV,
  logError,
  makeInvalid,
  clearInputValidation,
  addTracking,
  vv_fetch_state,
  showStateErrors,
  highlightFields
};

export default vv_utils;
